import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';

// Set global base URL for axios
// Set global base URL for axios
axios.defaults.baseURL = (process.env.REACT_APP_API_URL || 'http://127.0.0.1:3001').replace(/\/$/, '');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

